export const toasterModel = (text = "", type = toasterColor.success) => {
  return {
    text: text,
    color: type
  };
};

export const toasterColor = {
  success: "success",
  info: "orange",
  error: "error"
};
